const recipeArticleStyle = Object.freeze({});

export default recipeArticleStyle;
